import React, { useRef, useReducer } from 'react'
import {
  Button,
  DialogOverlay,
  DialogOverlayActions,
  DialogOverlayFooter,
  Select,
  TextArea,
  Checkbox,
  useOverlay,
} from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { getUser } from '@fs/zion-user'
import useNotifications from '../../../../hooks/useNotifications'
import * as queueService from '../../../../services/QueuesService'
import { OnOkCallback } from './useHolocaustDialog'

export function FamousDialog({ message, personId, personName, onSubmitCallback, onCancelCallback }) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const focusElementRef = useRef()
  const overlay = useOverlay()

  const initialState = {
    changeMessage: '',
    labelSelected: null,
    deleteMessage: true,
  }

  const reducer = (_, currentState) => ({ ...currentState })
  const [state, setState] = useReducer(reducer, initialState)

  const deleteResolution = `Famous - ${state.labelSelected}`

  const onOk = async () => {
    overlay.close()
    const user = await getUser()
    return queueService
      .queueButtonFamous(personId, state.labelSelected, user.cisId, state.changeMessage)
      .then(() =>
        OnOkCallback(message, personId, overlay, onSubmitCallback, error, state.deleteMessage, deleteResolution)
      )
  }

  const labelOptions = [
    ['queues.sensitiveIssuesFamousFamily', 'Sensitive issues - Famous Family'],
    ['queues.sensitiveIssuesFamousJewish', 'Sensitive issues - Famous Jewish'],
    ['queues.sensitiveIssuesFamousOther', 'Sensitive issues - Famous Other'],
    ['queues.sensitiveIssuesTragedy', 'Sensitive issues - Tragedy'],
    ['queues.sensitiveIssuesDisaster', 'Sensitive issues - Disaster'],
    ['queues.sensitiveIssuesPoliticsActivists', 'Sensitive issues - Politics/Activists'],
  ]

  return (
    <div>
      <Button onClick={overlay.handleClick}>{t('famous', 'Famous')}</Button>
      <DialogOverlay
        {...overlay}
        focusRef={focusElementRef}
        title={`${personName} (${personId}) - ${t('famous', 'Famous')}`}
      >
        <Select
          label={t('attribution.chooseLabel', 'Choose a Label')}
          options={labelOptions.map(([key, value]) => ({ value, label: t(key, value) }))}
          value={state.labelSelected}
          onChange={(event) => setState({ ...state, labelSelected: event.target.value })}
        />
        <TextArea
          ref={focusElementRef}
          label={t('reason', 'Reason')}
          value={state.changeMessage}
          onChange={(event) => setState({ ...state, changeMessage: event.target.value })}
        />
        <Checkbox
          label={t('queues.alsoDeleteMessage', 'Also Delete Message')}
          name="selectDeleteMessage"
          checked={state.deleteMessage}
          onChange={() => setState({ ...state, deleteMessage: !state.deleteMessage })}
        />

        <DialogOverlayFooter>
          <DialogOverlayActions>
            <Button onClick={onOk} emphasis="high">
              {t('action.ok', 'OK')}
            </Button>
            <Button
              onClick={() => {
                overlay.close()
                onCancelCallback?.()
              }}
              emphasis="medium"
            >
              {t('action.cancel', 'Cancel')}
            </Button>
          </DialogOverlayActions>
        </DialogOverlayFooter>
      </DialogOverlay>
    </div>
  )
}
